import { Canvas, useFrame } from "@react-three/fiber";
import { Float } from "@react-three/drei";
import { useRef } from "react";

const MAT = { roughness: 0.2, metalness: 0.8, clearcoat: 1 };

function Shapes() {
  const group = useRef();
  useFrame((state, delta) => {
    if (!group.current) return;
    group.current.rotation.y += delta * 0.12;
    group.current.rotation.x += (state.pointer.y * 0.25 - group.current.rotation.x) * 0.04;
    group.current.position.x += (state.pointer.x * 0.4 - group.current.position.x) * 0.04;
  });
  return (
    <group ref={group}>
      <Float speed={2} rotationIntensity={1.2} floatIntensity={1.6}>
        <mesh position={[0.4, 0.2, 0]}>
          <icosahedronGeometry args={[1.35, 0]} />
          <meshPhysicalMaterial color="#6C0B1B" {...MAT} />
        </mesh>
      </Float>
      <Float speed={1.6} rotationIntensity={2} floatIntensity={1.2}>
        <mesh position={[2.4, -1.2, -1]}>
          <torusKnotGeometry args={[0.5, 0.17, 140, 24]} />
          <meshPhysicalMaterial color="#A31621" {...MAT} />
        </mesh>
      </Float>
      <Float speed={2.4} rotationIntensity={1.5} floatIntensity={2}>
        <mesh position={[-2.3, 1.5, -1.4]}>
          <octahedronGeometry args={[0.6, 0]} />
          <meshPhysicalMaterial color="#8C1126" {...MAT} roughness={0.15} />
        </mesh>
      </Float>
      <Float speed={1.8} rotationIntensity={1} floatIntensity={1.4}>
        <mesh position={[-1.8, -1.6, -0.6]}>
          <torusGeometry args={[0.42, 0.14, 24, 64]} />
          <meshPhysicalMaterial color="#D4A24C" roughness={0.25} metalness={0.9} clearcoat={1} />
        </mesh>
      </Float>
    </group>
  );
}

export const Hero3D = () => (
  <div className="w-full h-full" role="img" aria-label="Floating 3D burgundy geometric shapes">
    <Canvas camera={{ position: [0, 0, 6.5], fov: 45 }} dpr={[1, 1.5]} gl={{ antialias: true, alpha: true }}>
      <ambientLight intensity={1.1} />
      <directionalLight position={[5, 6, 4]} intensity={2} />
      <directionalLight position={[0, 2, 8]} intensity={1.2} color="#FDFBF7" />
      <pointLight position={[-5, -3, 3]} intensity={60} color="#A31621" />
      <Shapes />
    </Canvas>
  </div>
);
